export default {
  'pages.platform.operations.material.manual.matching.model': '型号名称',
  'pages.platform.operations.material.manual.matching.category': '品类名称',
}
